function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_EVENTSASIDEVIEWBYAUTHUSERID_REQUEST = "GET_EVENTSASIDEVIEWBYAUTHUSERID_REQUEST";
export var GET_EVENTSASIDEVIEWBYAUTHUSERID_SUCCESS = "GET_EVENTSASIDEVIEWBYAUTHUSERID_SUCCESS";
export var GET_EVENTSASIDEVIEWBYAUTHUSERID_FAILURE = "GET_EVENTSASIDEVIEWBYAUTHUSERID_FAILURE";
export var RESET_GET_EVENTSASIDEVIEWBYAUTHUSERID = "RESET_GET_EVENTSASIDEVIEWBYAUTHUSERID";

// Fetches advisor aside view for a particular user from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
export var fetchEventsAsideViewByAuthUserId = function fetchEventsAsideViewByAuthUserId(authUserId) {
  var queryString = urlSearchParams({
    authUserId: authUserId
  });
  return _defineProperty({
    authUserId: authUserId
  }, CALL_API, {
    types: [GET_EVENTSASIDEVIEWBYAUTHUSERID_REQUEST, GET_EVENTSASIDEVIEWBYAUTHUSERID_SUCCESS, GET_EVENTSASIDEVIEWBYAUTHUSERID_FAILURE],
    endpoint: "eventsAsideViews/search/findByAuthUserId".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};